<div [formGroup]="formGroup" class="day-availability-selector bg-white rounded-md shadow-sm p-4"
  [class.day-availability-selector--expanded]="expanded">
  <div class="grid grid-cols-12 items-center w-full">
    <div class="day-availability-selector__day col-span-2 flex items-center self-baseline" [class.pl-4]="!editMode">
      <ng-container *ngIf="editMode">
        <!-- Icon to toggle the expansion panel -->
        <span class="day-availability-selector__toggle-icon cursor-pointer flex items-center" (click)="togglePanel()">
          <mat-icon>{{ expanded ? 'arrow_drop_down' : 'arrow_right' }}</mat-icon>
        </span>
        <mat-checkbox formControlName="selected"></mat-checkbox>
      </ng-container>
      {{ day }}
    </div>
    <!-- Time slots -->
    <ng-container *ngIf="timeSlotsControl">
      <div formArrayName="timeSlots" class="day-availability-selector__timeslot col-span-7">
        <section class="time-slot-container">
          <!-- Disabled state -->
          <div *ngIf="!expanded || !editMode; else timeSlotsForm">
            <ng-container *ngFor="let slot of timeSlotsControl.controls">
              <span class="mr-6">{{ slot.get('start')?.value }} - {{ slot.get('end')?.value }}</span>
            </ng-container>
          </div>

          <!-- Form group for time slots -->
          <ng-template #timeSlotsForm>
            <div *ngFor="let slot of timeSlotsControl.controls; let i = index" class="flex mb-3">
              <div [formGroupName]="i" class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="start" required>
                    <mat-option *ngFor="let segment of timeSegments" [value]="segment">
                      {{ segment }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <span class="mx-6">to</span>

                <mat-form-field appearance="outline">
                  <mat-select formControlName="end" required>
                    <mat-option *ngFor="let segment of timeSegments" [value]="segment">
                      {{ segment }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="actions ml-4 mt-[-5px]">
                <!-- Remove button -->
                <button mat-icon-button (click)="removeTimeSlot(i)">
                  <mat-icon>delete</mat-icon>
                </button>

                <!-- Add button -->
                <button mat-icon-button (click)="addTimeSlot()" *ngIf="i === timeSlotsControl.controls.length - 1">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
          </ng-template>
        </section>
      </div>
      <div class="day-availability-selector__hours col-span-3 flex justify-end items-center self-start">
        <span class="mr-4">
          <!-- Apply to whole week button -->
          <button mat-raised-button *ngIf="expanded && editMode" (click)="applyToWholeWeek()"
            [disabled]="!formGroup.valid" class="day-availability-selector__apply-to-all text-xs">
            Apply to selected
          </button>
        </span>
        <span class="min-w-[3rem]">
          {{ (timeSlotsControl.value)! | totalDuration }}
        </span>
      </div>
    </ng-container>
  </div>
</div>